// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"211":"dc93b713","285":"bd663955","304":"5de9fce3","497":"03ca8be1","530":"1bf869dc","976":"45adbe2f"}[chunkId] + ".chunk.js";
};